"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildType = void 0;
var BuildType;
(function (BuildType) {
    BuildType[BuildType["SCRIPT"] = 0] = "SCRIPT";
    BuildType[BuildType["SHELLCODE"] = 1] = "SHELLCODE";
})(BuildType = exports.BuildType || (exports.BuildType = {}));
